import { ChatSessionType, CircadianPhase } from '@demind-inc/core';
import {
  WbTwilight,
  Adjust,
  TrendingDown,
  TrendingUp,
  NotificationsPaused,
} from '@mui/icons-material';
import { ReactElement } from 'react';
import { PeakDipPhase, SuggestedEventType } from '../types';

const COLOR_RED = '#f34720';
const COLOR_GREEN = '#09c25a';
const COLOR_YELLOW = '#fdc913';
const COLOR_BLUE = '#3a92fa';

export const circadianPhaseInfo: Record<
  CircadianPhase,
  {
    color: string;
    title: string;
    label?: string;
    labelIcon?: ReactElement;
    explanation?: string;
    level?: string;
    imagePath?: string;
  }
> = {
  default: {
    title: '',
    color: COLOR_BLUE,
  },
  wakeup_low: {
    title: '🌞 Morning Warm-up',
    label: 'Warm-up',
    color: COLOR_RED,
    labelIcon: <WbTwilight style={{ color: COLOR_RED, fontSize: '14px' }} />,
    explanation: 'Warm-up! Good morning, set your self up for success!',
    level: 'low',
    imagePath: require('../../assets/zone/morning_warmup_graph.png'),
  },
  wakeup_normal: {
    title: '😎 Morning Standard',
    color: COLOR_YELLOW,
    label: 'Morning Standard',
    level: 'medium',
  },
  morning_high: {
    title: '🔥 Morning Peak',
    label: 'Morning Peak',
    color: COLOR_GREEN,
    labelIcon: <Adjust style={{ color: COLOR_GREEN, fontSize: '14px' }} />,
    explanation: 'Focus time! Work on deep tasks to maximize your productivity.',
    level: 'high',
    imagePath: require('../../assets/zone/morning_peak_graph.png'),
  },
  morning_normal: {
    title: '😎 Afternoon Standard',
    color: COLOR_YELLOW,
    label: 'Afternoon Standard',
    level: 'medium',
  },
  morning_low: {
    title: '☕️ Afternoon Dip',
    label: 'Afternoon Dip',
    color: COLOR_RED,
    labelIcon: <TrendingDown style={{ color: COLOR_RED, fontSize: '14px' }} />,
    explanation: 'Breather! Work on light tasks or take a break.',
    level: 'low',
    imagePath: require('../../assets/zone/afternoon_calm_graph.png'),
  },
  evening_normal: {
    title: '😎 Evening Standard',
    color: COLOR_YELLOW,
    label: 'Evening Standard',
    level: 'medium',
  },
  evening_high: {
    title: '🌙 Evening Peak',
    label: 'Evening Peak',
    color: COLOR_GREEN,
    labelIcon: <TrendingUp style={{ color: COLOR_GREEN, fontSize: '14px' }} />,
    explanation: 'Another peak! Finish the day on a high note.',
    level: 'high',
    imagePath: require('../../assets/zone/evening_peak_graph.png'),
  },
  evening_low: {
    title: '💤 Wind Down',
    label: 'Wind Down',
    color: COLOR_RED,
    labelIcon: <NotificationsPaused style={{ color: COLOR_RED, fontSize: '14px' }} />,
    explanation: "Wind down! Start winding down your day's activities.",
    level: 'low',
    imagePath: require('../../assets/zone/wind_down_graph.png'),
  },
};

export const zoneLevelColor: Record<string, string> = {
  low: COLOR_RED,
  medium: COLOR_YELLOW,
  high: COLOR_GREEN,
};

export const peakDipPhaseInfo: Omit<
  Record<
    PeakDipPhase,
    {
      title: string;
      color: string;
    }
  >,
  'evening_low'
> = {
  wakeup_low: { title: 'Morning Warm-up', color: '#f34720' },
  morning_high: { title: 'Morning Peak', color: '#09c25a' },
  morning_low: { title: 'Afternoon Dip', color: '#f34720' },
  evening_high: { title: 'Evening Peak', color: '#09c25a' },
};

export const SESSION_EMOJI: Record<SuggestedEventType, string> = {
  sleep: '😴',
  meal: '🍽️',
  task: '✅',
  scheduler: '📅',
  recommendation: '📅',
  general: '📅',
  routine: '🔄',
  workout: '💪',
};
